import * as momentTz from 'moment-timezone';
/**
 * @ngdoc service
 * @name mwDateRangeService
 * @module mw.components.dateRange
 *
 * @description
 * A service used for calculating date ranges.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#last7Days
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#last14Days
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#last30Days
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 *
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#last90Days
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 *
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#thisWeek
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 * @param {string} [locale] - Used to determine the start day of the week as specified in the Momentjs Locale data.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#thisMonth
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#lastMonth
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#thisQuarter
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#thisYear
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#lastQuarter
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#lastYear
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#today
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */
/**
 * @ngdoc method
 * @name mwDateRangeService#yesterday
 * @param {Date} relativeDate - The relative date to calculate the date range from.
 * @param {string} [timezone] - Timezone to be used for calculating date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @returns {{startDate: Date, endDate: Date, type: string}} The calculated date range and type.
 */

export class DateRangeService {
    public last7Days(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().subtract(6, 'days').startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'last7Days', name: 'Last 7 days' };
    }

    public last14Days(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().subtract(13, 'days').startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'last14Days', name: 'Last 14 days' };
    }

    public last30Days(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().subtract(29, 'days').startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'last30Days', name: 'Last 30 days' };
    }

    public thisWeek(
        date: Date = new Date(),
        timezone: string = momentTz.tz.guess(),
        locale: string = (navigator.language || navigator.userLanguage) ? (navigator.language || navigator.userLanguage).slice(0, 2) : 'en'
    ): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).locale(locale).endOf('day');
        let startDateMoment = endDateMoment.clone().startOf('week');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'thisWeek', name: 'This week' };
    }

    public thisMonth(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().startOf('month');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'thisMonth', name: 'This month' };
    }

    public lastMonth(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).subtract(1, 'months').endOf('month');
        let startDateMoment = endDateMoment.clone().startOf('month');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'lastMonth', name: 'Last month' };
    }

    public today(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'today', name: 'Today' };
    }

    public yesterday(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange{
        let endDateMoment = momentTz(date).tz(timezone).subtract(1, 'days').endOf('day');
        let startDateMoment = momentTz(date).tz(timezone).subtract(1, 'days').startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();
        return { startDate, endDate, type: 'yesterday', name: 'Yesterday' };
    }

    public thisQuarter(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().startOf('quarter');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'thisQuarter', name: 'This quarter' };
    }

    public lastQuarter(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).subtract(1, 'quarters').endOf('quarter');
        let startDateMoment = endDateMoment.clone().startOf('quarter');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'lastQuarter', name: 'Last quarter' };
    }

    public last90Days(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().subtract(89, 'days').startOf('day');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'last90Days', name: 'Last 90 days' };
    }

    public thisYear(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).endOf('day');
        let startDateMoment = endDateMoment.clone().startOf('year');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'thisYear', name: 'This year' };
    }

    public lastYear(date: Date = new Date(), timezone: string = momentTz.tz.guess(), locale?: string): DateRange {
        let endDateMoment = momentTz(date).tz(timezone).subtract(1, 'years').endOf('year');
        let startDateMoment = endDateMoment.clone().startOf('year');
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: 'lastYear', name: 'Last year' };
    }

    public limitEndToNow(dateRange, timezone: string = momentTz.tz.guess()) {
        let nowMoment = momentTz().tz(timezone);
        let endDateMoment = momentTz(dateRange.endDate).tz(timezone);
        if (endDateMoment.isAfter(nowMoment)) {
            endDateMoment = nowMoment;
        }
        let startDateMoment = momentTz(dateRange.startDate).tz(timezone);
        let startDate: Date = startDateMoment.toDate();
        let endDate: Date = endDateMoment.toDate();

        return { startDate, endDate, type: dateRange.type, name: dateRange.name };
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range.service.ts